export default "__VITE_ASSET__58224043__"